import './Spinner.css';

export const Spinner = ({ size = 14, style }) => (
    <span className="spinner" style={{ width: size, height: size, ...style }} role="status" aria-label="Loading" />
);
